import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ScrollFocusService {

  constructor(@Inject(PLATFORM_ID) private readonly platformID: string) { }
  scrollFocus(event={},elementId: string, page=''){    
    if(isPlatformBrowser(this.platformID)){
      const target = elementId.replace('#', '');
      const element:HTMLElement = document.getElementById(target);
      if(element){
        if(page==='pdp'){
          this.scrollPDPPage(element);          
        }else{
          this.scroll(element);
        }
        setTimeout(()=>this.setFocus(element),600);
      }
    }
  }
  private setFocus(element: HTMLElement){
    if(!element.hasAttribute(':focus')){
        const focusOptions={preventScroll: false, focusVisible: true}
        element.focus(focusOptions);
        if(!element.hasAttribute(':focus')){
          element.setAttribute('tabindex','-1');
          element.focus(focusOptions);
        }
      }
    }
  private scroll(element: HTMLElement){
      element?.scrollIntoView({behavior:'smooth',block:'start', inline: 'nearest'});
      element?.focus();
  }
  private scrollPDPPage(element: HTMLElement){
    let yOffset = (window.innerWidth >= 768 && window.innerWidth <= 1024) ? -90 : -150;
    yOffset = (window.innerWidth < 768) ? 0 : yOffset;
    const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
    window.scrollTo({ top: y, behavior: 'smooth' });
  }
}
